// extracted by mini-css-extract-plugin
export var avatarContainer = "_bg-0";
export var avatarTypingWave = "_bg-i";
export var gray = "_bg-f";
export var green = "_bg-c";
export var icon = "_bg-9";
export var image = "_bg-1";
export var lg = "_bg-6";
export var md = "_bg-5";
export var presenceDot = "_bg-b";
export var red = "_bg-d";
export var sm = "_bg-4";
export var status = "_bg-a";
export var typingDot = "_bg-h";
export var typingPill = "_bg-g";
export var xl = "_bg-7";
export var xs = "_bg-3";
export var xxl = "_bg-8";
export var xxs = "_bg-2";
export var yellow = "_bg-e";